import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Launcher from './Launcher';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';
import firebase from "firebase/app";
import "firebase/firestore"
import { getTimestamp, toTWDateStringOnlyNum } from './Helper';

const PWAHint = () => {

  const [updating, setUpdating] = useState(false)

  const onSWUpdate = (registration) => {
    if (window.Stockbook.reloadApp) { //1.2版 直接通知app更新 不需再冷啟動一次
      setUpdating(true)
      registration.waiting.postMessage({ type: 'SKIP_WAITING' }) //觸發更新
      setTimeout(() => {
        window.Stockbook.reloadApp()
        setUpdating(false)
      }, 888)
    } else {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' }) //觸發更新
    }
  }

  useEffect(() => {
    serviceWorkerRegistration.register({ onUpdate: onSWUpdate })
  })

  return (
    updating ? <div className="d-flex justify-content-center align-items-center" style={{
      zIndex: 3000,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,0.9)'
    }}>
      <div className="text-light" >
        <div className="spinner-border text-light" role="status" style={{ width: '1rem', height: '1rem', fontSize: '0.5rem' }}>
          <span className="sr-only">Loading...</span>
        </div>
        <span className="mx-2">更新中</span>
      </div>
    </div> : ''
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Launcher />
    <PWAHint />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

//Firebase 初始化
const firebaseConfig = {
  apiKey: "AIzaSyBazU1FfFTX9G4fSi9SGQacmwqGkZrYNZo",
  authDomain: "stockbook-web.firebaseapp.com",
  projectId: "stockbook-web",
  storageBucket: "stockbook-web.appspot.com",
  messagingSenderId: "1009425370478",
  appId: "1:1009425370478:web:d0de331f7ffc455113c57f"
};

firebase.initializeApp(firebaseConfig)
export const auth = firebase.auth()
//auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL) //確保登入資料保存
//auth.useEmulator('http://localhost:9099/')

export const db = firebase.firestore()
//db.useEmulator("localhost", 8080)
db.enablePersistence({ experimentalForceOwningTab: true })
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  })

//native call
window.ApiReturnTime = {}
window.httpGetResult = (result) => {
  const res = decodeURIComponent(result).split(';')
  const action = res[0]
  try {
    const data = JSON.parse(res[1])
    const apiRes = processJson(action, data)
    if (apiRes.e) {
      //發生例外
    } else {
      localStorage.setItem(action, JSON.stringify(apiRes))
      window.ApiReturnTime[action] = apiRes.t
    }
  } catch (e) {
    //發生例外
  }
}

//寫入VIP資訊
window.setVIPInfo = (vip) => {
  if (firebase.auth().currentUser !== null) {
    if (vip === "") { //2022.01.24 空值暫不移除VIP 可能google play使用其它帳號下載
      db.collection('users').doc(firebase.auth().currentUser.uid).get().then((doc) => {
        if (doc.exists && doc.data().vip) {
          const order = JSON.parse(doc.data().vip)
          db.collection('orders').doc(order.orderId)
            .set({ ...order, email: doc.data().email, ut: getTimestamp() }).then(() => {
              console.log("Document successfully updated!");
            }).catch((error) => {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
            })
        }
      })
    } else {
      db.collection('users').doc(firebase.auth().currentUser.uid).update({
        vip
      }).then(() => {
        console.log("Document successfully updated!");
      }).catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
    }
  }
}


export const processJson = (action, data) => {
  if (data.errorMsg) {
    return { e: data.errorMsg, t: getTimestamp() }
  }
  switch (action) {
    case 'StockInfoPZ':
      if (Array.isArray(data)) {
        let mergeData = { msgArray: [] }
        data.forEach(s => {
          mergeData.msgArray = [...mergeData.msgArray, ...JSON.parse(s).msgArray]
        })
        data = mergeData
      }
      let p = []
      const { msgArray } = data
      msgArray.forEach(m => {
        let hl = false //是否漲跌停
        let z = m.z
        //現價z無效
        if (m.t) { //下市股票可能會沒有時間
          let h = parseInt(m.t.split(':')[0])
          //盤中取價
          if (z === '-' && (h >= 9 && h < 14)) {
            z = m.a.split('_')[0] //取賣價
            if (z === '-') {
              z = m.b.split('_')[0] //取買價
              if (z === '0.0000') { //漲停
                z = m.b.split('_')[1]
              }
            } else if (z === '0.0000') { //跌停
              z = m.a.split('_')[1] //取賣價
            }
          }
          //盤後
          if (m.t === '13:30:00') {
            if (m.v !== '0') {
              //盤後無法取價狀況(尾盤未成交) 改由每日資料代入
              if (m.z === '-' && window.Stockbook && window.Stockbook.fetchMulti) { //1.4版才支援
                const date = parseInt(m.d.substring(0, 4)) - 1911 + '/' + m.d.substring(4, 6) + '/' + m.d.substring(6, 8)
                const di = JSON.parse(localStorage.getItem('DailyInfo'))

                //寫入需補收盤價的個股
                if (!di || di.d !== date) { //參照資料不存在或非當天
                  const data = { d: date, s: [{ id: m.c }], t: 0 }
                  localStorage.setItem('DailyInfo', JSON.stringify(data))
                } else if (di.d === date && di.s.filter(s => s.id === m.c).length === 0) {
                  let newS = di.s
                  newS.push({ id: m.c })
                  const data = { ...di, s: newS }
                  localStorage.setItem('DailyInfo', JSON.stringify(data))
                }

                if (di && di.d === date) {
                  const stock = di.s.filter(s => s.id === m.c)[0]
                  if (stock) {
                    if (stock.z && !isNaN(stock.z)) {
                      z = stock.z //補收盤價
                    }
                  }
                }
              }
            } else { //單日無成交 直接取昨收
              z = m.y
            }
          } else { //開盤中不需補資料
            localStorage.removeItem('DailyInfo')
          }
        }

        if (z === m.u || z === m.w) {
          hl = true
        }

        const pz = z === '-' ? parseFloat(m.y) : parseFloat(z)
        p.push({ id: m.c, pz, y: parseFloat(m.y), dt: m.d + m.t, hl })
      })
      return { p, t: getTimestamp() }
    case 'DailyInfo':
      //需整理既有資料
      const di = JSON.parse(localStorage.getItem('DailyInfo'))
      if (di) {
        const date = di.d
        data.forEach(str => { //native 會變成兩層json string
          const d = JSON.parse(str)
          if (d.stat === 'OK') { //處理上市資料
            const o = d.data.filter(a => a[0] === date)[0]
            if (o && !isNaN(o[6])) {
              const id = d.title.split(' ')[1]
              let stk = di.s.filter(s => s.id === id)[0]
              if (stk) {
                stk.z = o[6]
              }
            }
          } else if (d.stkNo) { //處理上櫃資料
            const o = d.aaData.filter(a => a[0] === date)[0]
            if (o && !isNaN(o[6])) {
              let stk = di.s.filter(s => s.id === d.stkNo)[0]
              if (stk) {
                stk.z = o[6]
              }
            }
          }
        })
      }
      return { ...di, t: getTimestamp() }
    case "TpexPZ":
      let newTp = { p: [] }
      if (data.aaData) { //更新即時價格
        let oldP = []
        if (localStorage.getItem('TpexPZ')) {
          const oldTp = JSON.parse(localStorage.getItem('TpexPZ'))
          oldP = oldTp.p
          if (oldTp.d !== toTWDateStringOnlyNum(new Date())) { //換日
            oldP = oldP.map(p => ({ ...p, y: p.pz })) //現價轉成昨日價
          }
        }

        data.aaData.forEach(d => {
          const idx = oldP.findIndex(p => p.id === d[0])
          if (d[10] !== 0) { //有成交價
            if (idx === -1) {
              newTp.p.push({ id: d[0], pz: d[10], y: d[2] })
            } else {
              newTp.p.push({ ...oldP[idx], pz: d[10] })
            }
          } else {
            if (idx === -1) {
              newTp.p.push({ id: d[0], pz: d[2], y: d[2] })
            } else {
              newTp.p.push({ ...oldP[idx] })
            }
          }
        })
        newTp.d = data.datetime_en.substring(0, 10).split('.').join('')
      }
      newTp.t = getTimestamp()
      return newTp
    default:
      return {}
  }

}
